
// File Auto-generated from LynxRestService project to ensure synchro of search keys
const FindKeyConstants = {
  MAX_SEARCH_RESULT: 1000,
  FR_CONTACT_TYPES: 'FR_CONTACT_TYPES',
  FR_CONTACT_USE_LIGHT_FORMAT_FIELDS: 'FR_CONTACT_USE_LIGHT_FORMAT_FIELDS',
  FR_CONTACT_ID: 'FR_CONTACT_ID',
  FR_CONTACT_IDS: 'FR_CONTACT_IDS',
  FR_CAND_FILTER_ON_ACTIVITY: 'FR_CAND_FILTER_ON_ACTIVITY',
  FIND_COUNT_RESULT_KEYWORD: 'FIND_COUNT_RESULT_KEYWORD',
  FR_FIND_MAX_VAL: 'FR_FIND_MAX_VAL',
  AUTOC_FILTER: 'AUTOC_FILTER',
  FR_ENTITY_CATEGORY: 'FR_ENTITY_CATEGORY',
  FR_ENTITY_SEARCH_ONLY_NAME: 'FR_ENTITY_SEARCH_ONLY_NAME',
  FR_ENTITY_SEARCH_EXTENDED: 'FR_ENTITY_SEARCH_EXTENDED',
  FR_CHECK_ONLY: 'FR_CHECK_ONLY',
  PREVIOUS_USER_GUID_FOR_NOPASSWD_LOGIN: 'PREVIOUS_USER_GUID_FOR_NOPASSWD_LOGIN',
  FR_ENC_PASSWD: 'FR_ENC_PASSWD',
  FR_LOGIN: 'FR_LOGIN',
  FR_LOGOUT: 'FR_LOGOUT',
  FR_CHECK_SESSION: 'FR_CHECK_SESSION',
  FR_RESTRICT_TO_CONTACT_TYPE: 'FR_RESTRICT_TO_CONTACT_TYPE',
  FR_IGNORE_CONTRIBUTORS: 'FR_IGNORE_CONTRIBUTORS',
  BO_USAGES_KEY: 'BO_USAGES_KEY',
  BO_USAGES_IGNORE_STRUCT_ACT: 'BO_USAGES_IGNORE_STRUCT_ACT',
  FR_VIEW_TYPE: 'FR_VIEW_TYPE',
  FR_CTX_ID: 'FR_CTX_ID',
  FR_ACT_SIDES: 'FR_ACT_SIDES',
  FR_ACT_REL_TO_CONTACT_ONLY: 'FR_ACT_REL_TO_CONTACT_ONLY',
  FR_ACT_4_CAND: 'FR_ACT_4_CAND',
  FR_ACT_4_CUST: 'FR_ACT_4_CUST',
  FR_ACT_4_OPP: 'FR_ACT_4_OPP',
  FR_ACT_WITH_PUSH: 'FR_ACT_WITH_PUSH',
  FR_ACT_SIDE: 'FR_ACT_SIDE',
  FR_ACT_TYPES: 'FR_ACT_TYPES',
  FR_ACT_ID: 'FR_ACT_ID',
  FR_ACT_IDS: 'FR_ACT_IDS',
  FR_OPP_ID: 'FR_OPP_ID',
  FR_OPP_IDS: 'FR_OPP_IDS',
  FR_OPP_CUSREF: 'FR_OPP_CUSREF',
  FR_OPP_CUSREFS: 'FR_OPP_CUSREFS',
  FR_OPP_ISSUERCTRL: 'FR_OPP_ISSUERCTRL',
  FR_OPP_ISSUER_POSID: 'FR_OPP_ISSUER_POSID',
  FR_OPP_ISSUER_POSIDS: 'FR_OPP_ISSUER_POSIDS',
  FR_POS_IDS: 'FR_POS_IDS',
  FR_POS_ID: 'FR_POS_ID',
  FR_POS_TYPE_IDS: 'FR_POS_TYPE_IDS',
  FR_POS_TYPE_ID: 'FR_POS_TYPE_ID',
  FR_LAST_EVENT_ONLY: 'FR_LAST_EVENT_ONLY',
  FR_CRIT_POS_SYNTH_STATE: 'FR_CRIT_POS_SYNTH_STATE',
  FR_USER_ID: 'FR_USER_ID',
  FR_USER_IDS: 'FR_USER_IDS',
  FR_USER_SHORTNAME: 'FR_USER_SHORTNAME',
  FR_ENTITY_ID: 'FR_ENTITY_ID',
  FR_ENTITY_IDS: 'FR_ENTITY_IDS',
  FR_PARENT_ENTITY_ID: 'FR_PARENT_ENTITY_ID',
  FR_PARENT_ENTITY_IDS: 'FR_PARENT_ENTITY_IDS',
  FR_ENTITY_BUILD_TREE: 'FR_ENTITY_BUILD_TREE',
  FR_CAND_ID: 'FR_CAND_ID',
  FR_CAND_IDS: 'FR_CAND_IDS',
  FR_ROLE_ID: 'FR_ROLE_ID',
  FR_ROLE_IDS: 'FR_ROLE_IDS',
  FR_SCRAPING_URL: 'FR_SCRAPING_URL',
  FR_CONNECTED_USERS: 'FR_CONNECTED_USERS',
  FR_FILTER_ON_ACTIVITY: 'FR_FILTER_ON_ACTIVITY',
  FR_ALLOW_SEARCH_ALREADY_MATCHED: 'FR_ALLOW_SEARCH_ALREADY_MATCHED',
  ACTIVITY_FORMAT_CALL_ID: 1,
  ACTIVITY_FORMAT_EMAIL_ID: 3,
  ACTIVITY_FORMAT_TASK_ID: 4,
  ACTIVITY_FORMAT_MEETING_ID: 2,
  ACTIVITY_FORMAT_NOTE_ID: 5,
  ENTITY_SOURCING_TYPE_NETWORKING_ID: 12,
  ENTITY_SOURCING_TYPE_COOPT1_ID: 5,
  ENTITY_SOURCING_TYPE_COOPT2_ID: 6,
  ENTITY_SOURCING_TYPE_COOPT3_ID: 7,
  ENTITY_SOURCING_TYPE_BDD_ID: 3,
  ENTITY_SOURCING_TYPE_ANNONCE_ID: 1,
  ENTITY_SOURCING_TYPE_FORUM_ID: 11,
  ENTITY_SOURCING_TYPE_SALON_ID: 13,
  ENTITY_SOURCING_TYPE_AFTWK_ID: 16,
  ENTITY_SOURCING_TYPE_INCONNU_ID: 8,
  NON_MANDATORY_SKILL_PROFILE_TYPE_ID: 51,
  POSITION_TYPE_Z_END_OF_TRACK_ID: 65,
  ACTIVITY_TYPE_CV_ID: 1,
  ACTIVITY_TYPE_CHASSE_ID: 3,
  ACTIVITY_TYPE_COOPT_ID: 4,
  ACTIVITY_TYPE_SOURCE_ID: 2,
  ACTIVITY_TYPE_EVENT_ID: 5,
  ACTIVITY_TYPE_RELANCE_CAND_ID: 6,
  ACTIVITY_TYPE_INTERVIEW1_CAND_ID: 7,
  ACTIVITY_TYPE_INTERVIEW1_RES1_CAND_ID: 10,
  ACTIVITY_TYPE_INTERVIEW1_RES2_CAND_ID: 11,
  ACTIVITY_TYPE_INTERVIEW1_RES3_CAND_ID: 12,
  ACTIVITY_TYPE_PROPAL_FAITE_CAND_ID: 16,
  ACTIVITY_TYPE_ACCEPT_CAND_ID: 17,
  ACTIVITY_TYPE_REFUS_DU_CAND_ID: 18,
  ACTIVITY_TYPE_POSITIONNEMENT_ID: 21,
  ACTIVITY_TYPE_INTERVIEW2_CAND_ID: 54,
  ACTIVITY_TYPE_INTERVIEW2_RES1_CAND_ID: 55,
  ACTIVITY_TYPE_INTERVIEW2_RES2_CAND_ID: 56,
  ACTIVITY_TYPE_INTERVIEW2_RES3_CAND_ID: 57,
  ACTIVITY_TYPE_PROPAL_A_FAIRE_CAND_ID: 58,
  ACTIVITY_TYPE_PROPAL_CAND_ACCEPT_ID: 59,
  ACTIVITY_TYPE_CAND_REFUS_ID: 68,
  ACTIVITY_TYPE_ANNONCE_ID: 70,
  ACTIVITY_TYPE_QUALIF_ID: 129,
  ACTIVITY_TYPE_QUALIF_TEL_NOK_ID: 131,
  ACTIVITY_TYPE_QUALIF_TEL_OK_ID: 130,
  ACTIVITY_TYPE_PROPAL_ID: 16,
  ACTIVITY_TYPE_ENTRETIEN_ID: 7,
  ACTIVITY_TYPE_ENTRETIEN2_ID: 54,
  ACTIVITY_TYPE_EVALTECHFCL_ID: 13,
  ACTIVITY_TYPE_EVALTECHFCLRES1_ID: 14,
  ACTIVITY_TYPE_EVALTECHFCLRES2_ID: 15,
  ACTIVITY_TYPE_EVALTECHFCLRES3_ID: 19,
  ACTIVITY_TYPE_OPP_INFOS_ID: 33,
  ACTIVITY_TYPE_DATE_ENTREE_ID: 71,
  ACTIVITY_TYPE_SIGN_CONTRAT_ID: 81,
  ACTIVITY_TYPE_DATE_RENOUV_PE_ID: 87,
  ACTIVITY_TYPE_FIN_PE_ID: 88,
  ACTIVITY_TYPE_BILAN_PE_ID: 91,
  ACTIVITY_TYPE_DATE_DEBUT_MISSION_ID: 47,
  ACTIVITY_TYPE_DATE_EVOL_POS_ID: 85,
  ACTIVITY_TYPE_DATE_SORTIE_ID: 41,
  ACTIVITY_TYPE_DATE_FIN_MISSION_ID: 83,
  ACTIVITY_TYPE_DATE_AVAIL_ID: 84,
  ACTIVITY_TYPE_GOCLIENT_ID: 24,
  ACTIVITY_TYPE_CODGAME_ID: 86,
  ACTIVITY_TYPE_RELANCE_ID: 90,
  ACTIVITY_TYPE_DATA_TEMPLATE_ID: 53,
  TYPE_INTERNAL_ID: 10,
  FR_FIRST_NAME_LAST_NAME: 'FR_FIRST_NAME_LAST_NAME',
  FR_POSITION_TYPES: 'FR_POSITION_TYPES',
  FR_EVENT_POSITION_TYPES: 'FR_EVENT_POSITION_TYPES',
  FR_POSITION_TYPE_ID: 'FR_POSITION_TYPE_ID',
  FR_POSITION_TYPE_IDS: 'FR_POSITION_TYPE_IDS',
  FR_CAND_STATES: 'FR_CAND_STATES',
  FR_CANDIDATES_ONLY: 'FR_CANDIDATES_ONLY',
  FR_ENTITY_SOURCING: 'FR_ENTITY_SOURCING',
  FR_XP: 'FR_XP',
  FR_RECRUITER: 'FR_RECRUITER',
  FR_CANDSALESSUPERV: 'FR_CANDSALESSUPERV',
  FR_CUSSALESSUPERV: 'FR_CUSSALESSUPERV',
  FR_OPPSALESSUPERV: 'FR_OPPSALESSUPERV',
  FR_TECHSUPERV: 'FR_TECHSUPERV',
  FR_CREATE_STARTDATE: 'FR_CREATE_STARTDATE',
  FR_CREATE_ENDDATE: 'FR_CREATE_ENDDATE',
  FR_CREATE_USER: 'FR_CREATE_USER',
  FR_MODIF_STARTDATE: 'FR_MODIF_STARTDATE',
  FR_MODIF_ENDDATE: 'FR_MODIF_ENDDATE',
  FR_MODIF_USER: 'FR_MODIF_USER',
  FR_CONT_STATES: 'FR_CONT_STATES',
  FR_CAND_LEG_STAT: 'FR_CAND_LEG_STAT',
  FR_CUST_STATES: 'FR_CUST_STATES',
  FR_CUSTOMERS_ONLY: 'FR_CUSTOMERS_ONLY',
  FR_MIXED_CAND_CUST: 'FR_MIXED_CAND_CUST',
  FR_EMPLOYEES_ONLY: 'FR_EMPLOYEES_ONLY',
  FR_ACCOUNT: 'FR_ACCOUNT',
  FR_ACCOUNTS: 'FR_ACCOUNTS',
  FR_ACCOUNTS_IN_POS: 'FR_ACCOUNTS_IN_POS',
  FR_ACCOUNT_AS_TEXT: 'FR_ACCOUNT_AS_TEXT',
  FR_TEAM: 'FR_TEAM',
  FR_TEAM_FIND_CATEGORY: 'FR_TEAM_FIND_CATEGORY',
  FR_INVIVOO_TEAMS: 'FR_INVIVOO_TEAMS',
  FR_INVIVOO_TEAMS_LIMITATION: 'FR_INVIVOO_TEAMS_LIMITATION',
  FR_CUSTOMER_TEAMS: 'FR_CUSTOMER_TEAMS',
  FR_CUSTOMER_TEAMS_LIMITATION: 'FR_CUSTOMER_TEAMS_LIMITATION',
  FR_RC_TEAMS: 'FR_RC_TEAMS',
  FR_RC_TEAMS_LIMITATION: 'FR_RC_TEAMS_LIMITATION',
  FR_RP_TEAMS: 'FR_RP_TEAMS',
  FR_RP_TEAMS_LIMITATION: 'FR_RP_TEAMS_LIMITATION',
  FR_CONSIDER_ALL_POSITIONS: 'FR_CONSIDER_ALL_POSITIONS',
  FR_COMBINE_INV_CUS_POS: 'FR_COMBINE_INV_CUS_POS',
  FR_OPP_TYPES: 'FR_OPP_TYPES',
  FR_OPP_SOURCES: 'FR_OPP_SOURCES',
  FR_OPP_SOURCE: 'FR_OPP_SOURCE',
  FR_OPP_STATES: 'FR_OPP_STATES',
  FR_OPP_XP_MIN: 'FR_OPP_XP_MIN',
  FR_ISSUER: 'FR_ISSUER',
  FR_PURCHASER: 'FR_PURCHASER',
  FR_ISSUE_FROM: 'FR_ISSUE_FROM',
  FR_CLOSING_FROM: 'FR_CLOSING_FROM',
  FR_CLOSING_TO: 'FR_CLOSING_TO',
  FR_ISSUE_TO: 'FR_ISSUE_TO',
  FR_POSREFCAREER: 'FR_POSREFCAREER',
  FR_POSREFPROJECT: 'FR_POSREFPROJECT',
  FR_POSREFGT: 'FR_POSREFGT',
  FR_POSREFHR: 'FR_POSREFHR',
  FR_SCHOOLS: 'FR_SCHOOLS',
  FR_DIPLOMA_YEAR: 'FR_DIPLOMA_YEAR',
  FR_SKILLS1: 'FR_SKILLS1',
  FR_COMBINE_SKILLS1: 'FR_COMBINE_SKILLS1',
  FR_SKILLS2: 'FR_SKILLS2',
  FR_SKILLS3: 'FR_SKILLS3',
  FR_ADVANCED_FIND_BY_SKILLS: 'FR_ADVANCED_FIND_BY_SKILLS',
  FR_SKILLS_STRICT_LIMIT: 'FR_SKILLS_STRICT_LIMIT',
  DOC_SEARCH_KEYWORDS: 'DOC_SEARCH_KEYWORDS',
  DOC_SEARCH_OPERAND: 'DOC_SEARCH_OPERAND',
  FR_TXT_SEARCH_IN_DOCS: 'FR_TXT_SEARCH_IN_DOCS',
  FR_TXT_SEARCH_IN_POS_DESCR: 'FR_TXT_SEARCH_IN_POS_DESCR',
  FR_ACT_USER: 'FR_ACT_USER',
  FR_ACT_ACT_TYPES: 'FR_ACT_ACT_TYPES',
  FR_ACT_DATE_FROM: 'FR_ACT_DATE_FROM',
  FR_ACT_DATE_TO: 'FR_ACT_DATE_TO',
  FR_ACT_STATES: 'FR_ACT_STATES',
  FR_ACT_INVERSE: 'FR_ACT_INVERSE',
  FR_ACT_REL_TO_ONLY: 'FR_ACT_REL_TO_ONLY',
  FR_ACT_LIMIT_TO_CTX: 'FR_ACT_LIMIT_TO_CTX',
  FR_ACT_LIMIT_TO_LAST: 'FR_ACT_LIMIT_TO_LAST',
  FR_PERSON_IMPORT: 'FR_PERSON_IMPORT',
  FR_PERSON_IMPORT_MAX_DAYS: 'FR_PERSON_IMPORT_MAX_DAYS',
  FR_PERSON_TYPE: 'FR_PERSON_TYPE',
  FR_PERSON_TYPES: 'FR_PERSON_TYPES',
  MATCH_CONTACT: 'MATCH_CONTACT',
  FR_ONLY_ROOT_PERSON_IMPORT: 'FR_ONLY_ROOT_PERSON_IMPORT',
  FR_PERSON_IMPORT_ID: 'FR_PERSON_IMPORT_ID',
  FR_PERSON_IMPORT_IDS: 'FR_PERSON_IMPORT_IDS',
  FR_PERSON_ID: 'FR_PERSON_ID',
  FR_PERSON_IDS: 'FR_PERSON_IDS',
  FR_PERSON_MORE_ID: 'FR_PERSON_MORE_ID',
  FR_PERSON_MORE_IDS: 'FR_PERSON_MORE_IDS',
  FR_OPEN_EVENTS: 'FR_OPEN_EVENTS',
  TEMPLATE_ENTRETIEN: 'TEMPLATE_ENTRETIEN',
  TEMPLATE_PROPALE: 'TEMPLATE_PROPALE',
  TEMPLATE_GEN_AO: 'TEMPLATE_GEN_AO',
  TEMPLATE_CRRH: 'TEMPLATE_CRRH',
  TEMPLATE_MAIL_QUALIF: 'TEMPLATE_MAIL_QUALIF',
  TEMPLATE_PRES_INVIVOO: 'TEMPLATE_PRES_INVIVOO',
  TEMPLATE1: 'TEMPLATE1',
  TEMPLATE2: 'TEMPLATE2',
  CONTRACT_TYPE_NEW_ID: 1,
  CONTRACT_TYPE_TARIF_ID: 5,
  FR_GET_ORGA_AROUND_POSITION_ID: 'FR_GET_ORGA_AROUND_POSITION_ID',
  FR_ORGA_VIEW_DATE: 'FR_ORGA_VIEW_DATE',
  FR_CONTRACT_ID: 'FR_CONTRACT_ID',
  FR_CONTRACT_IDS: 'FR_CONTRACT_IDS',
  FR_CONTRACT_TYPE_ID: 'FR_CONTRACT_TYPE_ID',
  FR_CONTRACT_TYPE_IDS: 'FR_CONTRACT_TYPE_IDS',
  FR_EST_TECH: 'FR_EST_TECH',
  FR_EST_TECHS: 'FR_EST_TECHS',
  FR_EST_FUNC: 'FR_EST_FUNC',
  FR_EST_FUNCS: 'FR_EST_FUNCS',
  FR_EST_GAL: 'FR_EST_GAL',
  FR_EST_GALS: 'FR_EST_GALS'
}
export default FindKeyConstants
